import { Link } from "react-router";
import { useAngemeldet } from "../sitzung";
import { Karte } from "../ui/Karte";
import { Leer } from "../ui/Leer";
import s from "./seiten.module.css";

const TAGE = new Intl.DateTimeFormat("de-DE", { weekday: "long", day: "2-digit", month: "2-digit", timeZone: "Europe/Berlin" });

/** Startseite „Meine Woche“. Bis das Aufgaben-Modul da ist, ein leerer Zustand. */
export function Start() {
  const { person } = useAngemeldet();
  return (
    <div className={s.stapel}>
      <div className={s.kopf}>
        <div>
          <h1>Meine Woche</h1>
          <p>Hallo {person.vorname || ""}. Das steht für dich an.</p>
          <p>{TAGE.format(new Date())}</p>
        </div>
      </div>
      <Karte>
        <Leer titel={`Hallo ${person.vorname || ""}, hier erscheinen bald deine Aufgaben.`}>
          Bis dahin kannst du dein <Link to="/profil">Profil</Link> einrichten.
        </Leer>
      </Karte>
    </div>
  );
}
